import axios from 'axios'
import { AnimatePresence, AnimateSharedLayout, motion } from 'framer-motion'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IUnit, IWarehouse } from 'safe'
import Empty from '../../../components/Display/Empty'
import Button from '../../../components/General/Button'
import useSnackBars from '../../../hooks/SnackbarConsumerHook'
import { useLocalStorageState } from '../../../hooks/useLocalStorageState'
import {
  cleanItems,
  fetchExistences,
  updateExistence,
} from '../../../redux/actions/existence'
import { RootState } from '../../../redux/store'
import ShowExistence from './ShowExistence'
import ShowItemsReady from './ShowItemsReady'
import ShowLocations from './ShowLocations'
import Truck from '../../../assets/animations/truck.json'
import ModalConfirm from '../../../components/Display/ModalConfirm'
import MantenimientoAnimation from '../../../assets/animations/truck.json'
const server = process.env.REACT_APP_SERVER_URL

const Transfers = () => {
  const dispatch = useDispatch()
  const { addAlert } = useSnackBars()

  const warehouses = useSelector((state: RootState) => state.warh.warehouses)
  // const existences = useSelector((state: RootState) => state.exst1.existences)

  const [confirmNegativeExistence, setConfirmNegativeExistence] =
    useState<boolean>(false)

  const [confirmCancel, setConfirmCancel] = useState<boolean>(false)

  const [showOrigins, setShowOrigins] = useState<boolean>(false)
  const [origin, setOrigin] = useState<IWarehouse | null>(null)

  const [showDestinations, setShowDestinations] = useState<boolean>(false)
  const [destination, setDestination] = useState<IWarehouse | null>(null)

  const [searchOrigin, setSearchOrigin] = useState<string>('')
  const [searchDestination, setSearchDestination] = useState<string>('')
  const [itemsToTransfer, setItemsToTransfer] = useState<ItemToTransfer[]>([])
  const [itemsReady, setItemsReady] = useState<ItemToTransfer[]>([])
  const [itemsToConfirm, setItemsToConfirm] = useState<
    {
      idItem: string
      amount: number
    }[]
  >([])

  const [existences, setExistences] = useState<any[]>([])

  const [userConfig] = useLocalStorageState('user-config')

  const [searchText, setSearchText] = useState<string>('')

  const getExistencesByWarehouse = async (
    location: IWarehouse
  ): Promise<void> => {
    await dispatch(
      fetchExistences(
        location.id,
        [],
        [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
      )
    )
  }

  const onGetExistencesByWarehouse = async () => {
    const response = await axios.get(`${server}/inventory/existence?id=${origin?.id}&pageNumber=${1}&pageSize=${userConfig.rowsPerPage}&fastSearch=${searchText}`)
    setExistences(response.data.items)
  }

  useEffect(() => {
    if (origin) {
      onGetExistencesByWarehouse()
    }
  }, [origin, searchText])

  useEffect(() => {
    return () => {
      dispatch(cleanItems())
    }
  }, [])

  const reset = (): void => {
    setOrigin(null)
    setDestination(null)
    setShowOrigins(false)
    setShowDestinations(false)
    setItemsReady([])
    setItemsToTransfer([])
    setSearchOrigin('')
    setSearchDestination('')
    setConfirmCancel(false)
    setItemsToConfirm([])
  }

  const cancelTransfer = () => {
    reset()
    addAlert({
      message: 'Transferencia cancelada',
      status: 'success',
    })
  }

  const checkTransfer = () => {
    let badQuantity = false
    let negativeExistence = false
    const itemsToPostLocal: {
      idItem: string
      amount: number
    }[] = []

    for (let i = 0; i < itemsReady.length; i++) {
      if (itemsReady[i].quantity <= 0) {
        badQuantity = true
        addAlert({
          message: `El artículo "${itemsReady[i].name}" debe poseer una cantidad mayor a cero`,
          status: 'error',
        })
        break
      }

      negativeExistence = itemsReady[i].originAvailable - itemsReady[i].quantity < 0

      itemsToPostLocal.push({
        idItem: itemsReady[i]?.id || '',
        amount: itemsReady[i]?.quantity || 1,
      })
    }

    if (badQuantity) return

    // if (negativeExistence) {
    //   setConfirmNegativeExistence(true)
    //   setItemsToConfirm(itemsToPostLocal)
    //   return
    // }
    makeTransfer(itemsToPostLocal)
  }

  const makeTransfer = async (itemsToPost) => {
    console.log("HACIENDO TRANSFERENCIA 1", origin)
    console.log("HACIENDO TRANSFERENCIA 2", destination)
    try {
      if (origin && destination) {

        // const unLoadBody = {
        //   destination: {
        //     id: origin.id,
        //     locationType: "WAREHOUSE"
        //   },
        //   items: itemsToPost,
        //   accounting: true
        // }

        // const loadBody = {
        //   destination: {
        //     id: destination.id,
        //     locationType: "WAREHOUSE"
        //   },
        //   items: itemsToPost,
        //   accounting: true
        // }

        const body = {
          source: {
            id: origin.id,
            locationType: "WAREHOUSE"
          },
          destination: {
            id: destination.id,
            locationType: "WAREHOUSE"
          },
          items: itemsToPost,
        }

        await axios.post(
          `${server}/inventory/transference`,
          body
        )

        addAlert({
          message: 'Transferencia realizada con éxito',
          status: 'success',
        })
        reset()
        return
      }
      addAlert({
        message:
          'Debe especificar el origen y destino para realizar una transferencia',
        status: 'error',
      })
      return
    } catch (error: any) {
      addAlert({
        message: error.response?.data?.message,
        status: 'error',
      })
    } finally {
      setConfirmNegativeExistence(false)
    }
  }
  useEffect(() => {
    console.log('itemsReady:', itemsReady)
  }, [itemsReady])

  useEffect(() => {
    console.log('itemsToTransfer:', itemsToTransfer)
  }, [itemsToTransfer])

  // return (
  //   <AnimatePresence>
  //   <Empty
  //     animationProps={{
  //       animation: MantenimientoAnimation,
  //       width: 250,
  //       height: 250,
  //     }}
  //   >
  //     <p className="font-semibold max-w-xs text-center my-4 text-sm text-coolGray-500">
  //     Estimado usuario, las transferencias se encuentran temporalmente en mantenimiento. 
  //     Disculpe las molestias ocasionadas.
  //     </p>
  //   </Empty>
  // </AnimatePresence>
  // )

  return (
    <AnimateSharedLayout>
      <motion.div
        key="origen"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="grid grid-cols-12 gap-4"
      >
        <div className="xl:col-span-6 col-span-12">
          <label htmlFor="source" className="text-primary-900 dark:text-white">
            Origen
          </label>
          <input
            type="text"
            className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
            name="source"
            value={searchOrigin}
            onChange={(e) => {
              setSearchOrigin(e.target.value)
              setOrigin(null)
              setItemsToTransfer([])
            }}
            onFocus={() => {
              setShowOrigins(true)
              setShowDestinations(false)
            }}
            autoComplete="off"
          />
          <ShowLocations
            showLocations={showOrigins}
            filterText={searchOrigin}
            setShowLocations={setShowOrigins}
            setSearchLocation={setSearchOrigin}
            locations={warehouses}
            setLocation={(value) => {
              // console.log('value:', value)
              setOrigin(value)
            }}
            getExistencesByWarehouse={getExistencesByWarehouse}
            notToShow={destination}
          ></ShowLocations>

          <motion.div layout className="overflow-hidden shadow rounded-lg">
            <ShowExistence
              onChangeText={setSearchText}
              existences={existences}
              setExistences={setExistences}
              itemsToTransfer={itemsToTransfer}
              setItemsToTransfer={(value) => {
                console.log("VALOR:", value)
                setItemsToTransfer(value)
              }}  
              origin={origin}
              notToShow={itemsReady}
            ></ShowExistence>
          </motion.div>
          {origin && destination && itemsToTransfer.length > 0 && (
            <Button
              type="primary"
              classes="w-full h-12 mt-5 mb-b"
              htmlType="button"
              onClick={() => {
                setItemsReady((state) => [...state, ...itemsToTransfer?.map(x => ({...x, quantity: 1, checked: false, originAvailable: x.quantity}))])
                setItemsToTransfer([])
                setExistences(existences?.map(x => ({...x, checked: false,})))
              }}
            >
              <span className="text-base mr-6">{itemsReady.length > 0 ? "Agregar" : "Siguiente"}</span>
            </Button>
          )}

          {itemsReady.length > 0 && itemsToTransfer.length === 0 && (
            <Button
              type="outline"
              classes="w-full h-12 mt-5 mb-b"
              htmlType="button"
              onClick={() => {
                setItemsReady((state) => [...state, ...itemsToTransfer])
                // setItemsToTransfer([])
                setConfirmCancel(true)
              }}
            >
              <span className="text-base mr-6">Cancelar</span>
            </Button>
          )}
        </div>

        <div className="xl:col-span-6 col-span-12">
          <label
            htmlFor="destination"
            className="text-primary-900 dark:text-white"
          >
            Destino
          </label>
          <input
            type="text"
            className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
            name="destination"
            value={searchDestination}
            onChange={(e) => {
              setSearchDestination(e.target.value)
              setDestination(null)
              setItemsReady([])
            }}
            onFocus={() => {
              setShowDestinations(true)
              setShowOrigins(false)
            }}
            autoComplete="off"
          />
          <ShowLocations
            showLocations={showDestinations}
            filterText={searchDestination}
            setShowLocations={setShowDestinations}
            setSearchLocation={setSearchDestination}
            locations={warehouses}
            setLocation={setDestination}
            notToShow={origin}
          ></ShowLocations>
          <motion.div layout className="overflow-hidden shadow rounded-lg">
            <ShowItemsReady
              itemsReady={itemsReady?.map(x => ({...x, quantity: x.quantity || 1}))}
              setItemsReady={setItemsReady}
              destination={destination}
              execute={checkTransfer}
            ></ShowItemsReady>
          </motion.div>
        </div>
      </motion.div>
      {}
      {!origin && !destination && !(showOrigins || showDestinations) && (
        <Empty
          animationProps={{
            height: 360,
            width: 300,
            animation: Truck,
          }}
          lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
        >
          <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
            Realice transferencias entre sus almacenes cómodamente
          </p>
        </Empty>
      )}
      <ModalConfirm
        onCancel={() => {
          setConfirmNegativeExistence(false)
          setItemsToConfirm([])
        }}
        onConfirm={() => {
          makeTransfer(itemsToConfirm)
        }}
        displayConfirmModal={confirmNegativeExistence}
        title="Algunos de los artículos que intenta transferir generarán una existencia negativa ¿Desea realizar esta transferencia?"
      />

      <ModalConfirm
        onCancel={() => setConfirmCancel(false)}
        onConfirm={() => {
          cancelTransfer()
        }}
        displayConfirmModal={confirmCancel}
        title="¿Desea cancelar la transferencia actual?"
      />
    </AnimateSharedLayout>
  )
}

export default Transfers

export interface ItemToTransfer {
  id: string
  name: string
  quantity: number
  barcode: string
  sku: string
  image: string
  unit: IUnit
  originAvailable: number
  destinationAvailable?: number
  checked?: boolean
}

